import {daliHelvarConstants} from "../constants/dali-helvar.constants";

const initStateHelvar = {
    helvarAreaList: null,
    helvarAreaItem: null,
    helvarGroupList: null,
    helvarGroupItem: null,
    helvarSceneList: null,
    validationForm: null
};

export function daliHelvarReducer(state = initStateHelvar, action) {
    switch (action.type) {
        case daliHelvarConstants.HELVAR_GROUP_LIST_REQUEST:
        case daliHelvarConstants.HELVAR_GROUP_LIST_FAILURE:
        case daliHelvarConstants.HELVAR_SCENE_LIST_REQUEST:
        case daliHelvarConstants.HELVAR_SCENE_LIST_FAILURE:
        case daliHelvarConstants.HELVAR_AREA_LIST_REQUEST:
        case daliHelvarConstants.HELVAR_AREA_LIST_FAILURE:
        case daliHelvarConstants.HELVAR_AREA_ITEM_REQUEST:
        case daliHelvarConstants.HELVAR_AREA_ITEM_FAILURE:
        case daliHelvarConstants.HELVAR_CLEAR:
            return {
                helvarGroupList: null,
                helvarSceneList: null,
                helvarGroupItem: null,
                helvarAreaList: null,
                helvarAreaItem: null,
                validationForm: null,
            };
        case daliHelvarConstants.HELVAR_GROUP_LIST_SUCCESS:
            return {
                ...state,
                helvarGroupList: action.groupsModel,
                validationForm: null
            };
        case daliHelvarConstants.HELVAR_GROUP_ITEM_SUCCESS:
            return {
                ...state,
                helvarGroupItem: action.groupItem,
                validationForm: null
            };
        case daliHelvarConstants.HELVAR_SCENE_LIST_SUCCESS:
            return {
                ...state,
                helvarSceneList: action.scenesModel,
                validationForm: null
            };
        case daliHelvarConstants.HELVAR_AREA_LIST_SUCCESS:
            return  {
                ...state,
                helvarAreaList: action.areaModel,
                validationForm: null
            };
        case daliHelvarConstants.HELVAR_AREA_ITEM_SUCCESS:
            return  {
                ...state,
                helvarAreaItem: action.areaSingleModel,
                validationForm: null
            };
        case daliHelvarConstants.HELVAR_VALIDATION_FORM: {
            return {
                ...state,
                validationForm: action.error.response.data
            };
        }
        default: {
            return  state
        }
    }
}


